import {StorageHelper} from '@/utils/storage';
import getAPLinkInfo, { getClient, isAPLink } from './client';
import { showToast } from 'vant';
import { Client, type Action } from "@amax/amaxup";
import { TransactConfig } from 'eosjs/dist/eosjs-api-interfaces';
// amaxup
const client = new Client();
// export type Actor = {
//   actor:string,
//   permission:string
// }
// export type Action = {
//   account: string; // 合约名称
//   name: string; // 合约方法名
//   data: any; // 合约参数
//   authorization?: Actor[];
// };

/**
 * amax
 * 调用合约
 */
export async function transact(actions: Action[],config?:TransactConfig) {
  if (!Array.isArray(actions) || !actions.length) {
    return;
  }

  // 过滤出正确的action
  actions = addAuthorization(actions.filter((item:any) => checkAction(item)));

  // const wallet = Storage.getItem('wallet');
  try {
    if ((window as any).armadillo) {
      return await (window as any).armadillo.transact({
        transaction: { // 同api的transact一样
          actions
        },
        // 此参数APLink暂时不支持
        config
        // config: { // 可以不传，具体类型 import { TransactConfig } from '@amax/amaxjs-v2/dist/eosjs-api-interfaces';
        //   broadcast: false,
        //   expireSeconds: 3610,
        // }
      });
    }
    
  } catch (e) {
    console.log(e,'from transact');
    
    const error: any = typeof e === 'string' ? JSON.parse(e) : e;
    // if (error?.error) {
    //   const { code, details = [] } = error.error;
    //   if (code === 3050003) {
    //     showToast(`${details[0].message}`)
    //   } else {
    //     // message.error(`${code}: ${intl.get(code)}`);
    //   }
    // }else if(error.message){
    //   if (isAPLink) {
    //     let errorMessage = JSON.parse(error.message)
    //     showToast(errorMessage.error.details[0].message)
    //   }else{
    //     showToast(`${error?.message}`)
    //   }
    // }
    throw e;
  }
}

function checkAction(action: Action) {
  const { account, data, name } = action;
  if (!account || !data || !name) {
    return false;
  }
  return true;
}

/**
 * 给action增加authorization属性
 * @param actions
 * @returns
 */
function addAuthorization(actions: Action[]): Action[] {
  const walletAddress = StorageHelper.getItem('walletAddress');
  const authority = StorageHelper.getItem('authority');
  for (const action of actions) {
    if (!action.authorization || action.authorization.length === 0) {
      action.authorization = [
        {
          actor: walletAddress,
          permission: authority,
        },
      ];
    }
  }
  return actions;
}

/**
 * Scatter发起交易
 * @param actions
 * @returns
 */
async function scatter(actions: Action[]) {
  const client = await getClient();
  return await client.transaction({ actions },{broadcast:false});
}

/**
 * Scatter发起交易
 * @param actions
 * @returns
 */
async function anchor(actions: Action[]) {
  const session = await window.__LINK__.restoreSession('amax.scan');
  return await session.transact({ actions },{broadcast:true});
}